import React, { useEffect } from 'react'
import {
	CheckCircleOutlined,
	RightCircleOutlined,
	RightCircleTwoTone,
	TableOutlined,
	BarChartOutlined,
} from '@ant-design/icons'
import c from 'classnames'
import gql from 'graphql-tag'
import _delay from 'lodash/delay'
import { useGlobalContext } from '@/components/context'
import { pharosAdminBaseUrl, pharosAdminSwitchOrgUrl, metabaseUrl } from '@/utils/url'
import { Switch } from '../pages/admin/switch-org/search-results/switch'
import { useAdminOrganisationsQuery } from './__gen/icon-admin'
import Icon from './icon'
import style from './icon-admin.module.sass'

gql`
	query adminOrganisations {
		adminOrgSwitchHistory_List(limit: 6, orderBy: [{ field: lastSwitch, direction: DESC }]) {
			objects {
				id
				organisation {
					id
					name
				}
			}
		}
	}
`

type Props = {
	closeDropdown: () => void
}

export const IconAdmin = ({ closeDropdown }: Props) => {
	const { organisation } = useGlobalContext()

	const { data, refetch } = useAdminOrganisationsQuery()

	useEffect(() => {
		refetch()
	}, [organisation.id])

	const options = (data?.adminOrgSwitchHistory_List?.objects || [])
		.filter((o) => o.organisation.id != organisation.id)
		.map((o) => ({
			name: (
				<Switch orgId={o.organisation.id}>
					<RightCircleOutlined />
					&nbsp; {o.organisation.name}
				</Switch>
			),
		}))

	return (
		<Icon
			iconLink={pharosAdminSwitchOrgUrl()}
			activePath={pharosAdminBaseUrl()}
			icon={'mediumLock'}
			title={
				<>
					<div>Superuser</div>
					<div className={style.currentOrgName}>
						<CheckCircleOutlined />
						&nbsp; {organisation.name}
					</div>
				</>
			}
			closeDropdown={closeDropdown}
			moveDropdown={-50 + -40 * options.length}
			links={[
				...options,
				{
					name: (
						<div className={c(style.selectGeneral)}>
							<RightCircleTwoTone />
							&nbsp; Select...
						</div>
					),
					to: pharosAdminSwitchOrgUrl(),
				},
				{
					name: (
						<div className={style.djangoAdmin}>
							<a href="/admin">
								<TableOutlined />
								&nbsp; Django admin
							</a>
						</div>
					),
				},
				{
					name: (
						<div className={style.selectGeneral}>
							<a href={metabaseUrl()}>
								<BarChartOutlined />
								&nbsp; Metabase
							</a>
						</div>
					),
				},
			]}
			small
		/>
	)
}
